import CodeHighlighter, { LanguageTypes } from 'molecules/CodeHighlighter';

const CodeSnippet: React.FC<{ children: any }> = (props) => {
  const { className, children } = props.children.props;

  const language =
    (className?.replace('language-', '') as LanguageTypes) ?? 'text';

  return <CodeHighlighter language={language}>{children}</CodeHighlighter>;
};

export default CodeSnippet;
